/**
 * Shapes data for Pilot POST /api/payments/cashfree/order (orderDetails) + Firestore txn,
 * and a cart-like itemDetails blob for OrderStatus / ItemsSummary.
 */

/**
 * @param {object} params
 * @param {string} params.userId
 * @param {object} params.pilotOrderPayload — body for Pilot POST /api/orders/ (no transactionRef yet)
 * @returns {{ cashfreeFlow: string, pilotOrderPayload: object, userId: string, itemDetails: object }}
 */
export function buildPilotInstoreCashfreeOrderDetails({ userId, pilotOrderPayload }) {
  const products = pilotOrderPayload.products || [];
  const totalCount = products.reduce((sum, p) => sum + (Number(p.quantity) || 0), 0);

  const itemDetails = {
    totalAmount: Number(pilotOrderPayload.total) || 0,
    totalCount,
  };

  products.forEach((p, i) => {
    const key = String(p.productId ?? `line_${i}`);
    itemDetails[key] = {
      name: p.name,
      count: Number(p.quantity) || 0,
      price: Number(p.price) || 0,
      urlId: p.productId,
      imgUrls: p.imageUrl ? [p.imageUrl] : [],
    };
  });

  return {
    cashfreeFlow: "pilot_instore",
    pilotOrderPayload,
    userId,
    itemDetails,
  };
}

export function isPilotPaymentState(state) {
  return Boolean(
    state?.storeDetails &&
      state?.cart?.products?.length &&
      state?.selectedSlot
  );
}

/** Rupees with 2 decimals for Cashfree order_amount */
export function roundCashfreeAmount(amount) {
  return Math.round(Number(amount) * 100) / 100;
}
